import { createAction } from '@reduxjs/toolkit';

// Group 1: CRUD Users
export const getUser = {
  request: createAction('user/getUserRequest'),
  success: createAction('user/getUserSuccess'),
  failed: createAction('user/getUserFailed'),
};

export const createUser = {
  request: createAction('user/createUserRequest'),
  success: createAction('user/createUserSuccess'),
  failed: createAction('user/createUserFailed'),
};

export const updateUser = {
  request: createAction('user/updateUserRequest'),
  success: createAction('user/updateUserSuccess'),
  failed: createAction('user/updateUserFailed'),
};

export const deleteUser = {
  request: createAction('user/deleteUserRequest'),
  success: createAction('user/deleteUserSuccess'),
  failed: createAction('user/deleteUserFailed'),
};

// User authentication actions
export const loginUser = {
  request: createAction('user/loginUserRequest'),
  success: createAction('user/loginUserSuccess'),
  failed: createAction('user/loginUserFailed'),
};

// Cookie tracking actions
export const cookieStatus = {
  setSent: createAction('user/cookieSetHeaderSent'), // Backend sent Set-Cookie header
  setConfirmed: createAction('user/cookieConfirmed'), // Cookie confirmed written
};


export const logoutUser = {
  request: createAction('user/logoutUserRequest'),
  success: createAction('user/logoutUserSuccess'),
  failed: createAction('user/logoutUserFailed'),
};


export const refreshUser = {
  request: createAction('user/refreshUserRequest'),
  success: createAction('user/refreshUserSuccess'),
  failed: createAction('user/refreshUserFailed'),
};

export const demoLoginUser = {
  request: createAction('user/demoLoginUserRequest'),
  success: createAction('user/demoLoginUserSuccess'),
  failed: createAction('user/demoLoginUserFailed'),
};

export const forgotPassword = {
  request: createAction('user/forgotPasswordRequest'),
  success: createAction('user/forgotPasswordSuccess'),
  failed: createAction('user/forgotPasswordFailed'),
};

export const resetPassword = {
  request: createAction('user/resetPasswordRequest'),
  success: createAction('user/resetPasswordSuccess'),
  failed: createAction('user/resetPasswordFailed'),
};

export const resendConfirmation = {
  request: createAction('user/resendConfirmationRequest'),
  success: createAction('user/resendConfirmationSuccess'),
  failed: createAction('user/resendConfirmationFailed'),
};

export const uploadAvatar = {
  request: createAction('user/uploadAvatarRequest'),
  success: createAction('user/uploadAvatarSuccess'),
  failed: createAction('user/uploadAvatarFailed'),
};